module.exports = __webpack_public_path__ + "img/runnics.22cd6c40.png";